// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"05155030","508":"54de92a1","524":"30099208","570":"c0175f23","672":"311d7a32","702":"fa9fc30a","708":"f37530ac"}[chunkId] + ".chunk.js";
};